import {Check} from "@sparkware/app-utils";

export class VersionNumber {
    constructor(public readonly major: number, public readonly minor: number, public readonly revision: number) {
    }

    static tryParse(version: string): VersionNumber | null {
        if(!version) {
            return null;
        }

        const parts = version.split('.');
        if(parts.length !== 3) {
            return null;
        }

        const major = parseInt(parts[0]);
        if(!Check.isNumber(major)) {
            return null;
        }

        const minor = parseInt(parts[1]);
        if(!Check.isNumber(minor)) {
            return null;
        }

        const revision = parseInt(parts[2]);
        if(!Check.isNumber(revision)) {
            return null;
        }

        return new VersionNumber(major, minor, revision);
    }

    toString(): string {
        return `${this.major}.${this.minor}.${this.revision}`;
    }

    static parse(version: string): VersionNumber {
        const v = VersionNumber.tryParse(version);
        if(v) {
            return v;
        }

        throw new Error(`Invalid version number ${version}`)
    }

    equals(otherVersion: VersionNumber): boolean {
        if(!otherVersion) {
            return false;
        }

        return this.major === otherVersion.major && this.minor === otherVersion.minor && this.revision === otherVersion.revision;
    }

    isSmallerThan(otherVersion: VersionNumber): boolean {
        if(!otherVersion) {
            return false;
        }

        if(this.major < otherVersion.major) {
            return true;
        } else if(this.major > otherVersion.major) {
            return false;
        }

        if(this.minor < otherVersion.minor) {
            return true;
        } else if(this.minor > otherVersion.minor) {
            return false;
        }

        if(this.revision < otherVersion.revision) {
            return true;
        } else {
            return false;
        }
    }

    isGreaterThan(otherVersion: VersionNumber): boolean {
        return !this.isSmallerThan(otherVersion);
    }


}